module.exports = __webpack_public_path__ + "img/wrestling.ccfe30fc.svg";